<template>
    <div id="container">
      <div id="pdftron"></div>

      <v-dialog />
    </div>
</template>

<script>
import WebViewer from '@pdftron/webviewer'
import axios from 'axios';
import $ from 'jquery';
import baseUrl from '../../services/baseUrl';
import search from '../../services/search';

const client = axios.create({
  baseURL: baseUrl.getBaseUrl(),
  withCredentials: true
});

export default {
  name: 'pdfTron',
  serverCacheKey: props => null,
  props: {
    src: String,
    searchText: String,
    searchOptions: Object,
  },
  emits: ['update:searchText', 'update:searchOptions'],
  data () {
    return {
      webViewerInstance: null,
    }
  },
  watch: {
    searchText(newVal) {  
      // Set previous search if any
      if (this.webViewerInstance) {
        //console.log("srcTxt", this.searchText);
        //this.webViewerInstance.searchTextFull(this.searchText, this.searchOptions);
      }
    }, 
    searchOptions(newVal) {   
      // Set previous search if any
      if (this.webViewerInstance) {
        //console.log("srcTxt", this.searchText);
        //this.webViewerInstance.searchTextFull(this.searchText, this.searchOptions);
      }
    }
  },
  methods: {
    init() {
      let pdfUrl = this.src;

      let container = document.getElementById('pdftron');
      container.innerHTML = '';
      WebViewer({
        path: window.location.origin + '/static/pdfTron'
      }, container)
        .then(instance => {
          let getPdfBlob = (data) => {
            const arrayBuffer = Buffer.from(data, 'binary');
            const arr = new Uint8Array(arrayBuffer);
            const blob = new Blob([arr], { type: 'application/pdf' });
            return blob;
          };
          let loadDocument = (data) => {
            let blob = getPdfBlob(data);
            instance.loadDocument(blob);
          };

          client({
            url: pdfUrl,
            responseType: 'arraybuffer'
          }, {
            withCredentials: true
          }).then(req => {
            loadDocument(req.data);

            // show print and download buttons in the header
            instance.setHeaderItems(header => {
              header.push({
                type: 'actionButton',
                img: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#abb0c4;}</style></defs><title>icon - header - print - line</title><path class="cls-1" d="M20,6H18V2H6V6H4A2,2,0,0,0,2,8v9a2,2,0,0,0,2,2H6v3H18V19h2a2,2,0,0,0,2-2V8A2,2,0,0,0,20,6ZM8,4h8V6H8Zm8,16H8V16h8Zm4-3H18V14H6v3H4V8H20Zm-4-7h2v2H16Zm-3,0h2v2H13Z"></path></svg>',
                onClick: () => {
                  instance.print();
                }
              });
              header.push({
                type: 'actionButton',
                img: `<svg class="downloadIcon" width="80" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 24">
                        <text x="25" y="16" fill="black">Scarica</text>
                        <defs><style>.cls-1{fill:#abb0c4;}</style></defs>
                        <title>icon - header - download</title>
                        <path class="cls-1" d="M11.55,17,5.09,9.66a.6.6,0,0,1,.45-1H8.67V2.6a.6.6,0,0,1,.6-.6h5.46a.6.6,0,0,1,.6.6V8.67h3.13a.6.6,0,0,1,.45,1L12.45,17A.6.6,0,0,1,11.55,17ZM3.11,20.18V21.6a.4.4,0,0,0,.4.4h17a.4.4,0,0,0,.4-.4V20.18a.4.4,0,0,0-.4-.4h-17A.4.4,0,0,0,3.11,20.18Z"></path>
                       </svg>
                `,
                onClick: () => {
                  let blob = getPdfBlob(req.data);
                  const link = document.createElement('a')
                  link.href = URL.createObjectURL(blob)
                  link.download = "Sentenza"
                  link.click()
                  URL.revokeObjectURL(link.href)
                }
              });
            });

            // adjust the style to properly show the download icon
            let downloadIcon = $("#pdftron iframe").contents().find('.downloadIcon');
            downloadIcon.parent().css("width", "auto");
            downloadIcon.parent().parent().css("width", "auto");
          }).catch(error => {
            if(error.response !== undefined && error.response.status === 505) {
              /* Visualizzazione limitata della sentenza

              //abbonamento scaduto, tolgo selezione del testo
              loadDocument(error.response.data);

              instance.disableFeatures([instance.Feature.TextSelection, instance.Feature.Search]);
              instance.disableElements(['printButton', 'downloadButton', 'searchPanel']);

              // Mostro solamente poche righe del documento per volta
              $("#pdftron iframe").contents().find(".document-content-container").css("max-height", "100px");

              this.$modal.show('dialog', {
                title: 'Non sei abbonato alla rivista',
                text: "L'accesso libero non consente di <b>cercare</b> e <b>copiare</b> il testo e di stampare o scaricare la sentenza. Inoltre la visualizzazione della stessa è limitata.",
                buttons: [
                  {
                    title: 'Chiudi',
                    handler: () => {
                      this.$modal.hide('dialog')
                    }
                  },
                  {
                    title: 'Abbonati',
                    handler: () => {
                      location.href = "/utente";
                    }
                  }
                ]
              })
              */

              this.$modal.show('dialog', {
                title: 'Non sei abbonato alla rivista',
                text: "Abbonati per poter visualizzare la sentenza.",
                buttons: [
                  {
                    title: 'Chiudi',
                    handler: () => {
                      this.$modal.hide('dialog')
                    }
                  },
                  {
                    title: 'Abbonati',
                    handler: () => {
                      location.href = "/utente";
                    }
                  }
                ]
              })
            }
          });

          const docViewer = instance.docViewer;
          const annotManager = instance.annotManager;
          // call methods from instance, docViewer and annotManager as needed

          // you can also access major namespaces from the instance as follows:
          // const Tools = instance.Tools;
          // const Annotations = instance.Annotations;

          instance.setReadOnly(true);
          instance.setLanguage('it');
          instance.disableElements([ 'toggleNotesButton' ]);

          docViewer.on('documentLoaded', () => {            
            instance.searchTextFull(this.searchText, this.searchOptions);
          });
          instance.addSearchListener((searchValue, options, results) => {
            this.$emit('update:searchText', searchValue);
            this.$emit('update:searchOptions', options);
          });

          // hide the gear button
          instance.disableElements(['menuButton']);

          if(!this.isMobile()){
            instance.openElements([ 'searchPanel' ]);

            docViewer.on('documentLoaded', () => {
              instance.setZoomLevel("150%");
            });
          }

          this.webViewerInstance = instance;
        })
    },
    isMobile() {
      return ('ontouchstart' in document.documentElement);
    }
},
  activated(){
    this.init();
  },
  deactivated(){
    this.webViewerInstance.dispose();
  }
}
</script>

<style>
#pdftron{
  height: 90vh;
}

.Button.ActionButton {
  width: auto !important;
}

.vue-dialog-content{
  background-color: #00a4e4;
}
</style>



// WEBPACK FOOTER //
// src/components/PdfTron/PdfTron.vue